<template>
    <v-card class="rounded-card">
      <v-card-title>
        <v-row align="center" justify="center">
            <h3 class="primary--text font-weight-black text-uppercase">
              Resumen de venta
            </h3>
        </v-row>
      </v-card-title>
      <v-card-title class="pt-0">
        <v-row align="center" justify="center">
          <v-col class="py-0 mx-1">
             <v-alert
              class="mb-0 animate__animated animate__shakeX"
              outlined
              type="warning"
              prominent
              dense
              icon="mdi-lightbulb-on"
              transition="scale-transition"
              border="left">
                <strong class="primary--text">Ahorra tiempo vendiendo cuantas facturas desees en un solo paso, sin importar que sean de diferentes clientes y/o monedas.</strong>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 500px;">
        <v-simple-table dense>
          <template v-slot:default>
            <thead class="text-uppercase">
              <tr>
                <th class="text-center primary--text font-weight-black" style="width: 32%;">Razón Social</th>
                <th class="text-center primary--text font-weight-black" style="width: 10%;">Folio</th>
                <th class="text-center primary--text font-weight-black" style="width: 10%;">Orden Compra</th>
                <th class="text-right primary--text font-weight-black" style="width: 15%;">Importe</th>
                <th class="text-center primary--text font-weight-black" style="width: 12%;">Fecha de emisión</th>
                <th class="text-center primary--text font-weight-black" style="width: 12%;">Fecha para pago</th>
                <th class="text-center primary--text font-weight-black" style="width: 10%;">Días de crédito</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in invoicesToSell"
                :key="item.documentId"
                class="row-summary"
              >
                <td class="text-center text-uppercase">{{ item.receiverName }}</td>
                <td class="text-center text-uppercase">{{ item.folio }}</td>
                <td class="text-center text-uppercase">{{ item.purchaseOrder || '-'}}</td>
                <td class="text-right text-uppercase">{{ item.total | currency }} {{ item.currency }}</td>
                <td class="text-center text-uppercase">{{ item.emittedOn }}</td>
                <td class="text-center text-uppercase font-weight-bold">{{ item.dueDate }}</td>
                <td class="text-center text-uppercase font-weight-bold">{{ item.paymentDays }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-row align="center" justify="center" class="my-2">
            <h3 class="text-center primary--text font-weight-black">¿Las facturas tienen los datos deseados?</h3>
        </v-row>
        <v-row align="center" justify="center">
            <h3 class="py-2" style="color: #263238">Asegúrate de revisar todos los datos, ya que una vez que hayas vendido las facturas <span class="font-weight-black text-decoration-underline">no se permiten cambios.</span></h3>
        </v-row>
        <v-row align="center" justify="center" class="my-0 mx-0">
          <v-checkbox
              class="my-0 mx-0"
              v-model="sendSummary"
              background-color="red"
              color="#0420BF">
            <template v-slot:label>
              <div class="sendSummary">
                Enviar una copia del resumen de venta a mi correo
              </div>
            </template>
          </v-checkbox>
        </v-row>
        <v-row align="center" justify="center">
            <v-btn
              large
              rounded
              color="#B0BEC5"
              @click="$emit('onClose', false, sendSummary)"
              class="font-weight-black mr-4">
              <v-icon left>mdi-window-close</v-icon> Quiero corregir/agregar facturas</v-btn>
              <v-btn
              dark
              large
              rounded
              color="#5C9DF2"
              @click="$emit('onClose', true, sendSummary)"
              class="font-weight-black">
              <v-icon left>mdi-check</v-icon>Sí, los datos son correctos</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'SaleSummary',
  props: {
    invoicesToSell: Array
  },
  data () {
    return {
      sendSummary: true
    }
  }
}
</script>

<style scoped>
  .row-summary td {
    font-size: 12.5px!important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .sendSummary {
    color: #FF6D00 !important;
    font-weight: bolder !important;
    font-size: 0.9vw !important;
  }
</style>
